<template>
    <div>
        <page-title>数据统计</page-title>
        <page-body>
            <div>
                <div flex="box:last">
                    <div flex="cross:center" style="font-size: 16px">访问记录</div>
                    <div>
                        <el-date-picker
                                @change="historyDateChange"
                                v-model="history.date"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                </div>
                <div v-loading="history.loading">
                    <canvas :id="history.id"
                            style="width: 970px;height: 360px"></canvas>
                </div>
            </div>
            <hr>
            <div>
                <div flex="box:last">
                    <div flex="cross:center" style="font-size: 16px">任务记录</div>
                    <div>
                        <el-date-picker
                                @change="taskDateChange"
                                v-model="task.date"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                </div>
                <div v-loading="task.loading">
                    <canvas :id="task.id"
                            style="width: 970px;height: 360px"></canvas>
                </div>
            </div>
        </page-body>
    </div>
</template>

<script>
import axios from '@/axios'
import Chart from 'chart.js'
import helper from '@/helper'

export default {
    data() {
        return {
            history: {
                id: 'history',
                url: 'admin/data/history',
                loading: true,
                date: null,
                chart: null,
                form: {},
                datas: null
            },
            task: {
                id: 'task',
                url: 'admin/data/task',
                loading: true,
                date: null,
                chart: null,
                form: {},
                datas: null
            }
        }
    },
    created() {
        this.loadData()
    },
    methods: {
        loadData() {
            this.loadItemData(this.history)
            this.loadItemData(this.task)
        },
        historyDateChange() {
            this.loadItemData(this.history)
        },
        taskDateChange() {
            this.loadItemData(this.task)
        },
        loadItemData(item) {
            let startDate = null
            let endDate = null
            if (!item.date) {
                startDate = new Date()
                endDate = new Date()
            } else {
                startDate = item.date[0]
                endDate = item.date[1]
            }
            item.form.start_date = helper.dateFormat('yyyy-MM-dd', startDate)
            item.form.end_date = helper.dateFormat('yyyy-MM-dd', endDate)
            item.loading = true
            axios({
                url: item.url,
                params: item.form
            }).then(e => {
                item.loading = false
                if (e.data.code === 0) {
                    if (item.chart) {
                        item.chart.destroy()
                    }
                    item.chart = new Chart(item.id, this.generateChartOption(e.data.data))
                } else {
                    this.$message.error(e.data.msg)
                }
            }).catch(e => {
            })
        },
        generateChartOption(datas) {
            const res = {
                type: 'line',
                data: {
                    labels: [],
                    datasets: [],
                    fill: 'start'
                },
                options: {
                    elements: {
                        line: {
                            tension: 0
                        }
                    }
                }
            }
            for (let i in datas) {
                res.data.labels = []
                const dataset = {
                    label: `${datas[i].group}(${datas[i].count})`,
                    data: [],
                    backgroundColor: 'rgba(29, 162, 210, .1)',
                    borderColor: datas[i].color || 'rgba(29, 162, 210, 1)',
                    borderWidth: 3,
                    pointRadius: 2
                }
                for (let j in datas[i].list) {
                    res.data.labels.push(datas[i].list[j].time)
                    dataset.data.push(datas[i].list[j].count)
                }
                res.data.datasets.push(dataset)
            }
            return res
        }
    }
}
</script>

<style scoped>

</style>
